// Imports
import { plainToClass } from "class-transformer";
import { Member } from "./document-library-members";
import { EditDocumentSection, EditDocumentTreeLoader } from "../document-tree/editable-document-tree/edit-document-tree";


// Define the DocumentLibraryMemberPage class
export class EditDocumentLibraryMemberPage {
    private members: Member[] = []; // Array to store member data
    private dataTable: any; // Reference to the DataTable instance
    documentViewModal: any;
    //list of user emails
    visibleUserEmails: string = "";


    constructor(documentSections: EditDocumentSection[], memberList: any[], targetFile: string = "", targetSearchBox: string = "") {
        // Initialize the DocumentLibraryLoaderWithSharepoint
        let documentlibrary = new EditDocumentTreeLoader(documentSections, targetFile, targetSearchBox);

        // Call a separate method to handle additional functionality
        this.processData(memberList);

        
    }

    // New method to process data and initialize the DataTable
    private processData(memberList: any[]): void {
        // Convert raw data into Member instances
        if (memberList) {
            this.members = plainToClass(Member, <Member[]>memberList);
        } else {
            console.error("No members found in the JSON data.");
            return; // Exit early if no data is found
        }

        // Initialize the DataTable when the DOM is ready
        $(() => {
            this.createFilters(); // Create and populate the filters
            this.initializeTable(); // Initialize the DataTable
            this.addFilterListeners(); // Add event listeners for filters
        });
    }

    // Initialize the DataTable
    private initializeTable(): void {
        // Check if there are any members to display
        if (!this.members || this.members.length === 0) {
            console.error("No members available to display in the table.");
            return;
        }

        // Initialize the DataTable with member data
        this.dataTable = $('#member-list-table').DataTable({
            data: this.members,
            columns: [
               /** {
                    title: "Member Name",
                    render: (data: any, type: string, row: Member) => this.generateDropdownMenu(row) // Use helper for dropdown
                },**/
                {
                    title: "Member Name",
                    data:  (row: Member, type, val, meta) =>{
                        if (type == "display") {
                            return this.getDisplayName(row);

                        }
                        else if (type == "sort") {
                            return row.LastName;

                        }
                        return row;
                    }
                },
                { data: "Role", title: "Role(s)", render: (data) => { return data.join(", ") } },               
                { data: "DisplayCenters", title: "Center(s)", render: (data) => { return data.join(", ") } }
            ],
            paging: false,
            searching: false,
            info: false,
            scrollX: false,
            scrollY: '70vh',
            scrollCollapse: true,
            dom: 'Bfrtip', // Required for buttons functionality
            buttons: [
                {
                    text: '<i class="fas fa-envelope"></i>',
                    titleAttr: 'Send Email',
                    action: () => this.handleEmailCopy() // Call shared method
                }

            ],
            order: []
        });

        // Update the visible email list whenever the table is filtered or searched
        this.dataTable.on('search.dt', () => {
            const visibleRows = this.dataTable.rows({ search: 'applied' }).data().toArray();
            this.updateEmailList(visibleRows); // Update emails based on visible rows
        });

        // Append the dynamically created email button to the custom container
        this.dataTable.buttons().container().appendTo('#buttons-container');

        // Initialize the visible email list by default
        this.updateEmailList(this.members);

        $(`#member-list-table tbody`).on('click', 'td', (event) => {
            $("#detail-menu-container").find(".revampp-dropdown-menu").removeClass("show");
        });
    }

    private getMenuContent(userEmail: string): string {
        // Generates a dropdown menu for each row in the DataTable- each is a toggle and selectable
        let foundMember: Member = this.members.find(member => member.Email == userEmail);
        if (foundMember) {
            return `
                <div class="font-weight-bold font-size14 px-4 py-1 nowrap">
                    ${foundMember.FirstName} ${foundMember.LastName}
                </div>
                <!-- Email Link -->
                <a class="dropdown-item" href="mailto:${foundMember.Email}">
                    <i class="fa-solid fa-envelope blue-icon"></i><span class="pl-2"> Email</span>
                </a>
                <!-- ORCID Link -->
                ${foundMember.OrcIdLink ? `
                    <a class="dropdown-item" href="${foundMember.OrcIdLink}" target="_blank">
                        <i class="fa-brands fa-orcid blue-icon"></i> <span class="pl-2"> ORCID </span>
                    </a>` : ""}
                <!-- LinkedIn Link -->
                ${foundMember.LinkedInLink ? `
                    <a class="dropdown-item" href="${foundMember.LinkedInLink}" target="_blank">
                        <i class="fa-brands fa-linkedin blue-icon"></i> <span class="pl-2"> LinkedIn </span>
                    </a>` : ""}
                        <!-- Bio Link -->
                ${foundMember.BioLink ? `
                    <a class="dropdown-item" href="${foundMember.BioLink}" target="_blank">
                        <i class="fas fa-external-link-alt blue-icon"></i> <span class="pl-2"> External Bio </span>
                    </a>` : ""}
            `;
        }
        else {
            return "";
        }

        
    }

    getDisplayName(row: Member): string {
        let userMenu = `
        <div class="btn-group dropright">
            <button type="button" class="dropdown-toggle user-name-select" data-toggle="dropdown" data-id="${row.Email}" aria-haspopup="true" aria-expanded="false" onclick="page.updateMenuPosition(event)">
                <span class="underline">${row.FirstName} ${row.LastName}</span>
            </button>
            <div class="dropdown-menu revampp-dropdown-menu ml-2">

            </div>
        </div>
        `

        return userMenu;
    }

    private handleEmailCopy(): void {
        if (!this.visibleUserEmails.trim()) {
            alert("No visible emails to copy!");
            return;
        }
        navigator.clipboard.writeText(this.visibleUserEmails).then(() => {
            $('#directory-email-modal').modal('show'); // Show modal
            $('#modal-email-list').text(this.visibleUserEmails); // Update modal content
        });
    }

    // Method to update the visible email list
    private updateEmailList(visibleMembers: Member[]): void {
        this.visibleUserEmails = visibleMembers.map(member => member.Email).join("; ");
    }


    private createFilters(): void {
        const roles = Array.from(new Set(this.members.flatMap(member => member.Role)));
        const centers = Array.from(new Set(this.members.flatMap(member => member.DisplayCenters)));

        //Role filter
        const roleFilter = $('#role-filter'); // Select the Role filter element
        roles.forEach(role => {
            const option = `<option value="${role}" selected>${role}</option>`;
            roleFilter.append(option); // Add each role as an <option>
        });

        //Center filter
        const centerFilter = $('#center-filter'); // Select the Center filter element
        centers.forEach(center => {
            const option = `<option value="${center}" selected>${center}</option>`;
            centerFilter.append(option); // Add each center as an <option>
        });

        // Initialize the selectpickers globally- set all
        $('.selectpicker').selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",
            countSelectedText: (numSelected, numTotal) => {
                return numSelected === numTotal ? "All" : `${numSelected} Selected`;
            }
        });
       
    }

    private addFilterListeners(): void {
        // Add listeners for role and center filters to trigger filtering
        $('#role-filter').on('changed.bs.select', () => this.triggerFilter());
        $('#center-filter').on('changed.bs.select', () => this.triggerFilter());

        // Add event listener for the Clear Filters button
        $('#clear-filters-btn').on('click', () => {
            // Reset only the role and center filters- avoid messing up other picklists on page
            $('#role-filter option').prop('selected', true);
            $('#center-filter option').prop('selected', true); 

            // Refresh the selectpickers to reflect changes
            $('#role-filter').selectpicker('refresh');
            $('#center-filter').selectpicker('refresh');

            // Reset the table to show all members
            this.dataTable.order([]); // Reset sorting to default
            this.updateTable(this.members);

            // Reset the email list to include all members
            this.updateEmailList(this.members);
        });
    }

    private triggerFilter(): void {
        const selectedRoles = $('#role-filter').val() as string[] | null;
        const selectedCenters = $('#center-filter').val() as string[] | null;

        // If either filter is empty, clear the table and email list
        if (!selectedRoles || selectedRoles.length === 0 || !selectedCenters || selectedCenters.length === 0) {
            this.updateTable([]); // Clear the table
            this.updateEmailList([]); // Clear the email list
            return;
        }

        // Filter members based on roles and centers
        const filteredMembers = this.members.filter(member => {
            const matchesRole = member.Role.some(r => selectedRoles.includes(r)) // Role check
            const matchesCenter = member.DisplayCenters.some(center => selectedCenters.includes(center)); // Center check
            return matchesRole && matchesCenter; // Both conditions must be true
        });

        // Provide feedback if no members match the filters
        if (filteredMembers.length === 0) {
            return;
        }

        // Update the table and email list with the filtered members
        this.updateTable(filteredMembers);
        this.updateEmailList(filteredMembers);

    }

    private updateTable(filteredMembers: Member[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(filteredMembers).draw();
    }

    private setIframeSrc(link: string, title: string = ""): void {
        let viewDocTitle = $("#view-document-modal").find("#filename");
        let viewDocContent = $("#view-document-modal").find("#document-iframe");

        viewDocTitle.text(title);
        viewDocContent.prop('src', link);
    }
   
    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);

        // empty any existing menus (menus are moved to this div to avoid overflow issues with table)
        $("#detail-menu-container").empty();

        let dropdownMenu = targetElement.siblings('.revampp-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        let userId = targetElement.data("id");

        // Check is the dropdown menu has been moved to the new #detail-menu-container 
        if (dropdownMenu.length <= 0) {
            // if the menu has already been moved, remove existing dropdwon relationship, and create a new one with new menu options
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu revampp-dropdown-menu ml-2">
                    ${this.getMenuContent(userId)}
                </div>
            `)
            targetElement.dropdown();
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.revampp-dropdown-menu');
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            // if the menu has not already been moved (first click), just add the correct menu options.
            dropdownMenu.html(`
                ${this.getMenuContent(userId)}
            `)
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".revampp-dropdown-menu");
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

}